const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- {}]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const emailSignaturOptions = [
  "Use the user email signature",
  "Use this signature",
  "Use the system default signature",
  "No signature",
];

export const smsTemplateFields = [
  {
    id: "template_name",
    label: "Template Name",
    placeHolder: "Enter template name",
    type: "text",
    isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "lead_stage",
    label: "Lead Stage",
    placeHolder: "Select lead stage",
    type: "select",
    isRequired: true,
    options: [],
  },

  {
    id: "event",
    label: "Event",
    placeHolder: "select",
    type: "select",
    options: [],
    isRequired: true,
  },
  // {
  //   id: "signature_option",
  //   label: "Signature",
  //   placeHolder: "select",
  //   type: "select",
  //   options: [
  //     {
  //       label: "Use the user email signature",
  //       id: "user_email_signature",
  //     },
  //     { label: "Use custom signature", id: "custom_signature" },
  //     {
  //       label: "Use the system default signature",
  //       id: "system_default_signature",
  //     },
  //     { label: "No signature", id: "no_signature" },
  //   ],
  //   isRequired: true,
  // },

  // {
  //   id: "signature",
  //   label: "Signature",
  //   placeHolder: "Enter signature",
  //   type: "richtext",
  //   minRows: 2,
  //   autocomplete: "off",
  // },

  // {
  //   id: "disclaimer",
  //   label: "Disclaimer",
  //   placeHolder: "Enter disclaimer",
  //   type: "textarea",
  //   minRows: 3,
  //   inputProps: {
  //     maxLength: 255,
  //   },
  //   isRequired: true,
  //   patternAllowed: patternConstant?.ALPHANUMERIC,
  // },
  {
    id: "body",
    label: "Body",
    placeHolder: "Enter body",
    type: "textarea",
    minRows: 3,
    maxLength: 1600,
    // inputProps: {
    //   maxLength: 1600,
    // },
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];

export const SEND_SMS_TEMPLATE_FIELDS = [
  {
    id: "to",
    label: "Recipient Phone Number",
    placeHolder: "Enter recipient phone number",
    type: "autocomplete",
    isRequired: true,
    options: [],
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  
  {
    id: "message",
    label: "Body",
    placeHolder: "Enter body",
    type: "editor",
    minRows: 4,
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC,
    firstColmd: 2.5,
    md: 9.5,
  },
];

export const emailTagFields = [
  {
    label: "{{date}}",
  },
  {
    label: "{{username}}",
  },
  {
    label: "{{today}}",
  },
  {
    label: "{{useremail}}",
  },
  {
    label: "{{usermobile}}",
  },
  {
    label: "{{ref}}",
  },
  {
    label: "{{addrline}}",
  },
  {
    label: "{{toaddrline}}",
  },
  {
    label: "{{email}}",
  },
  {
    label: "{{password}}",
  },
];
